import { AlertIcon } from '@approvalmax/ui';
import { Box } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const Root = styled(Box)`
    background-color: #cb4e30;
`;

export const StyledAlertIcon = styled(AlertIcon)`
    & > path {
        fill: #ffd213;
    }
`;
